import 'ol/ol.css';
import ImageLayer from 'ol/layer/Image';
import Map from 'ol/Map';
import Projection from 'ol/proj/Projection';
import Static from 'ol/source/ImageStatic';
import View from 'ol/View';
import {getCenter} from 'ol/extent';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import {Circle as CircleStyle, Style, Fill, Stroke, Text} from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import MultiPoint from 'ol/geom/MultiPoint';
import GeoJSON from 'ol/format/GeoJSON';
import {Select, defaults as defaultInteractions} from 'ol/interaction';
import LayerGroup from 'ol/layer/Group';
import {ZoomToExtent, Control, defaults as defaultControls} from 'ol/control';
import ScaleLine from 'ol/control/ScaleLine';
import * as Modules from './modules/modules.js';

// Map views always need a projection.  Here we just want to map image
// coordinates directly to map coordinates, so we create a projection that uses
// the image extent in pixels.
var upperMapExtent = [0, 0, 2047, 1458];

// define here paths to image files for the lower view
// their size and their pixel size
const pics = {
  'pic01': {
    url:'images/01_Soma_nearPeri_I.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6, // um
  },
  'pic02': {
    url:'images/02_Soma_nearNuc.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic03': {
    url:'images/03_Soma_nearPeri_II.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic04': {
    url:'images/04_Base_AxonDend.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic05': {
    url:'images/05_Axon_base.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic06': {
    url:'images/06_AlongAxon.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic07': {
    url:'images/07_Axon_termi.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic08': {
    url:'images/08_Dend_base.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic09': {
    url:'images/09_Prox_dend.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic10': {
    url:'images/10_Synapses_alongDen.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic11': {
    url:'images/11_Dist_dend.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },
  'pic12': {
    url:'images/12_Dend_termi.png',
    extent:[0, 0, 4007, 2671],
    imageSize:[4008, 2672],
    metersPerUnit: 0.00108419e-6,  // um
  },


}

// define ROIs as geojsonObject
var geojsonObject = {
  'type': 'FeatureCollection',
  'crs': {
    'type': 'name',
    'properties': {
      'name': 'EPSG:3857',
    },
  },
  'features': [
    {
      'type': 'Feature',
	  'id': 'pic01',
	  'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [788, 661],
            [828, 661],
            [828, 621],
            [788, 621],
            [788, 661] ] ],
      },
	  'properties': {
        'info': '<b>Filename:</b> 01_Soma_nearPeri_I.png<br>' +
            '<em>1. Soma near periphery I: Here, long ER profiles consisting of ER sheets studded with ' +
            'ribosomes and multiple ER contacts , eg. ER-mitochondria, ER-PM and ER exit sites can be ' +
            'seen in the image\n</em>',
        'name': '01',
	  }
    },
    {
      'type': 'Feature',
      'id': 'pic02',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [780, 680],
            [820, 680],
            [820, 640],
            [780, 640],
            [780, 680] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 02_Soma_nearNuc.png<br>' +
            '<em>2. Soma near nucleus: Relatively shorter ER profiles are seen consisting ' +
            'of ribosome studded sheets in perinuclear area, tubular ER near Golgi and ' +
            'ribosome studded ER sheets near mitochondria</em>',
        'name': '02',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic03',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [766, 782],
            [806, 782],
            [806, 742],
            [766, 742],
            [766, 782] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 03_Soma_nearPeri_II.png<br>' +
            '<em>3. Soma near periphery II: Long ER profiles – ribosome studded sheets. ' +
            'Multiple types of ER-other organelle contacts including ER-mitochondria, ' +
            'ER-PM, ER-lysosome can be seen</em>',
        'name': '03',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic04',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [628, 763],
            [668, 763],
            [668, 723],
            [628, 723],
            [628, 763] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 04_Base_AxonDend.png<br>' +
            '<em>4. Base of axon and dendrite: This region is marked by relatively shorter ' +
            'ER profiles – ribosome studded sheets and tubules, a sparsity of ' +
            'polyribosomes especially at the axon base is seen</em>',
        'name': '04',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic05',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [615, 734],
            [655, 734],
            [655, 694],
            [615, 694],
            [615, 734] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 05_Axon_base.png<br>' +
            '<em>5. Axon hillock region: Has relatively shorter ER profiles – ' +
            'ribosome studded sheets and tubules, fewer or almost absent ribosome ' +
            'clusters or polyribosomes compared to that in soma region</em>',
        'name': '05',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic06',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [507, 423],
            [547, 423],
            [547, 383],
            [507, 383],
            [507, 423] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 06_AlongAxon.png<br>' +
            '<em>6. Along Axon: Abundance of ER tubule profiles of different length and width, ' +
            'ribosomes are present but in relatively far lesser density than in cell soma ' +
            'and dendrites, ER sheets studded ribosomes are scarce if present</em>',
        'name': '06',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic07',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [342, 62],
            [382, 62],
            [382, 22],
            [342, 22],
            [342, 62] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 07_Axon_termi.png<br>' +
            '<em>7. Axon terminal: Tubules of different lengths and lumen width, ' +
            'branched, ER sheets with and without ribosomes</em>',
        'name': '07',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic08',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [832, 688],
            [872, 688],
            [872, 648],
            [832, 648],
            [832, 688] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 08_Dend_base.png<br>' +
            '<em>8. Dendrite base: ER sheets and tubules of different ' +
            'lengths and lumen width, branched profiles are seen in this region</em>',
        'name': '08',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic09',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [916, 630],
            [956, 630],
            [956, 590],
            [916, 590],
            [916, 630] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 09_Prox_dend.png<br>' +
            '<em>9. Proximal dendrite: ER tubules of different lengths ' +
            'and lumen width, branched; Polyribosomes are seen apart from other organelles</em>',
        'name': '09',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic10',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [911, 694],
            [951, 694],
            [951, 654],
            [911, 654],
            [911, 694] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 10_Synapses_alongDen.png<br>' +
            '<em>10. Synapses along dendrite: ER tubules of different lengths and lumen width</em>',
        'name': '10',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic11',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [1262, 520],
            [1302, 520],
            [1302, 480],
            [1262, 480],
            [1262, 520] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 11_Dist_dend.png<br>' +
            '<em>11. Distal dendrite: Shorter branched ER tubules are present along the dendrite length distally</em>',
        'name': '11',
      }
    },
    {
      'type': 'Feature',
      'id': 'pic12',
      'geometry': {
        'type': 'Polygon',
        'coordinates': [
          [
            [1614, 435],
            [1654, 435],
            [1654, 395],
            [1614, 395],
            [1614, 435] ] ],
      },
      'properties': {
        'info': '<b>Filename:</b> 12_Dend_termi.png<br>' +
            '<em>12. Dendrite terminal: Elongated ER sheets and tubules are seen in this region</em>',
        'name': '12',
      }
    },
   ],
};

var projection = new Projection({
  code: 'pixel',
  units: 'pixels',
  extent: upperMapExtent,
  metersPerUnit: 0.103175e-6, // in um
});

//
// Define scale to 100% control
//
var Set100ProcControl = /*@__PURE__*/(function (Control) {
  function Set100ProcControl(opt_options) {
    var options = opt_options || {};

    var button = document.createElement('button');
    button.innerHTML = '1:1';

    var element = document.createElement('div');
    element.className = 'set-to-100proc ol-unselectable ol-control';
    element.appendChild(button);

    Control.call(this, {
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleSetTo100proc.bind(this), false);
  }

  if ( Control ) Set100ProcControl.__proto__ = Control;
  Set100ProcControl.prototype = Object.create( Control && Control.prototype );
  Set100ProcControl.prototype.constructor = Set100ProcControl;

  Set100ProcControl.prototype.handleSetTo100proc = function handleSetTo100proc () {
    this.getMap().getView().setResolution(1);
  };

  return Set100ProcControl;
}(Control));

// ----------------------------------------------------
// Labels inside polygons and polygon styles
// ----------------------------------------------------
// Create text and define its style
var createTextStyle = function (feature, resolution) {
  return new Text({
    font: '12px Calibri,sans-serif',
    fill: new Fill({color: '#fff'}),
    text: feature.get('name'),
  });
};

// polygonStyleFunction
function polygonStyleFunction(feature, resolution) {
  return new Style({
    stroke: new Stroke({
      color: 'red',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 0, 0, 0.1)',
    }),
    text: createTextStyle(feature, resolution),
  });
}

/*
// alternative style to use if text is not needed
// if text is needed the lower function is used
var styles = [
  //* We are using two different styles for the polygons:
  //*  - The first style is for the polygons themselves.
  //*  - The second style is to draw the vertices of the polygons.
  //*    In a custom `geometry` function the vertices of a polygon are
  //*    returned as `MultiPoint` geometry, which will be used to render
  //*    the style.
  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 3,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  }),
  new Style({
    image: new CircleStyle({
      radius: 1,
      fill: new Fill({
        color: 'orange',
      }),
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint(coordinates);
    },
  }) ];
*/

// define map as a static image, provide link and size of the image
var map = new Map({
  controls: defaultControls().extend([new Set100ProcControl(), new ZoomToExtent(), new ScaleLine()]),
  layers: [
    new ImageLayer({
      source: new Static({
        attributions: '© <a href="https://www.helsinki.fi/en/infrastructures/bioimaging/embi">EMBI</a><br>Images by Sreesha Sree<br>Page arrangement by Ilya Belevich',
        url: 'images/Neuron_ER_cartoon_V3.png',   // remember to copy images to dist manually!
		imageSize: [2048, 1459],
        projection: projection,
        imageExtent: upperMapExtent,
      }),
    }),
    /*
	new LayerGroup({
      layers: [
        new ImageLayer({
		  source: new Static({
			attributions: '© <a href="https://www.helsinki.fi/en/infrastructures/bioimaging/embi">EMBI</a>',
			url: 'images/Neuron_ER_cartoon_V3.png',   // remember to copy images to dist manually!
			imageSize: [2048, 1459],
			projection: projection,
			imageExtent: upperMapExtent,
		  }),
		}),
        ],
    }) */
	],
  target: 'map',
  view: new View({
    projection: projection,
    center: getCenter(upperMapExtent),
	//resolution: 1,
    zoom: 1,
    maxZoom: 8,
  }),
});
// fit the upper view to fit the canvas
map.getView().fit(upperMapExtent);

// define layer to be displayed on the lower map view
var currentSecondLayer = '';

// create a new map for the lower image
// init it with the first 'pic1' in the list
var secondMapInitId = 'pic10';

var map2 = new Map({
	controls: defaultControls().extend([new Set100ProcControl(), new ZoomToExtent(), new ScaleLine()]),
	layers: [
      new ImageLayer({
        source: new Static({
          attributions: '© <a href="https://www.helsinki.fi/en/infrastructures/bioimaging/embi">EMBI</a><br>Images by Sreesha Sree<br>Page arrangement by Ilya Belevich',
		  url: pics[secondMapInitId].url,
          imageSize: pics[secondMapInitId].imageSize,
          projection: projection,
          imageExtent: pics[secondMapInitId].extent,
        }),
      }),
    ],
    target: 'map2',
    view: new View({
		projection: new Projection({
			code: 'pixel',
			units: 'pixels',
			extent: pics[secondMapInitId].extent,
            metersPerUnit: pics[secondMapInitId].metersPerUnit,
		}),
		center: getCenter(pics[secondMapInitId].extent),
		zoom: 1,
		maxZoom: 8,
	}),
});  
// fit the upper view to fit the canvas
map2.getView().fit(pics[secondMapInitId].extent);

// function to update the map layer upon selection of a ROI in the upper map
function updateLayer( picId ){
  let extent = pics[picId].extent;
  let imageSize = pics[picId].imageSize;
  let metersPerUnit = pics[picId].metersPerUnit;
  
  // create a new layer
  let newLayer = new ImageLayer({
        source: new Static({
          attributions: '© <a href="https://www.helsinki.fi/en/infrastructures/bioimaging/embi">EMBI</a><br>Images by Sreesha Sree<br>Page arrangement by Ilya Belevich',
          url: pics[picId].url,
          imageSize: imageSize,
          projection: new Projection({
			code: 'pixel',
			units: 'pixels',
			extent: extent,
		  }),
          imageExtent: extent,
        }),
  });
  
  if (newLayer !== currentSecondLayer) {
    // have to generate a new view to provide new pixel size
    let view = new View({
      projection: new Projection({
        code: 'pixel',
        units: 'pixels',
        extent: pics[picId].extent,
        metersPerUnit: pics[picId].metersPerUnit,
      }),
      center: getCenter(pics[picId].extent),
      zoom: 1,
      maxZoom: 8,
    });

   map2.addLayer(newLayer);
   map2.removeLayer(currentSecondLayer);
   map2.setView(view);
   map2.getView().setZoom(1);
   map2.getView().fit(extent);
   currentSecondLayer = newLayer;
  }
}

// Popup showing the position the user clicked
var popup = new Overlay({
  element: document.getElementById('popup'),
});
map.addOverlay(popup);

// create feature source
var featuresSource = new GeoJSON().readFeatures(geojsonObject);

// create vector source
var vectorSource = new VectorSource({
  features: featuresSource,
});

// create vector layer and add it to map
var vectorLayer = new VectorLayer({
  source: vectorSource,
  //style: styles,
  style: polygonStyleFunction,
});
map.addLayer(vectorLayer);

// add Select action to map to highlight select feature
map.addInteraction(new Select());

// function to detect id of the clicked feature
var displayFeatureInfo = function (pixel) {
  vectorLayer.getFeatures(pixel).then(function (features) {
    var feature = features.length ? features[0] : undefined;
    
	var info = document.getElementById('info');
    if (features.length) {
      currentSecondLayer = updateLayer(feature.getId(), currentSecondLayer);
	  //console.log(feature.get('info'));
	  info.innerHTML = feature.get('info');
	  //info.innerHTML = feature.getId() + ': ' + feature.get('name');
    } else {
      //info.innerHTML = '&nbsp;';
    }
  });
};

// bind slider inputs to functions
Modules.setupBindInputs('#layer', map.getLayerGroup());

$('#layertree li > span')
  .click(function () {
    $(this).siblings('fieldset').toggle();
  })
  .siblings('fieldset')
  //.hide();

map.on('click', function (evt) {
  displayFeatureInfo(evt.pixel);
});



// Display also a popup with coordinate info
/*
map.on('click', function (evt) {
  var element = popup.getElement();
  var coordinate = evt.coordinate;

  $(element).popover('dispose');
  popup.setPosition(coordinate);
  $(element).popover({
    container: element,
    placement: 'top',
    animation: false,
    html: true,
    content: '<p>The location you clicked was:</p><code>' + coordinate + '</code>',
  });
  $(element).popover('show');
  displayFeatureInfo(evt.pixel);
  //console.log('coordinates: ' + coordinate);
});
*/

